import React, { useState } from 'react'
import Slider from 'react-slick'
import useStyles, { FormInputSelect } from './styles'
import Navbar2 from '../../components/Navbar2/Navbar2'
import Section from '../../components/Section/Section'
import Footer from '../../components/Footer/Footer'
import FormInputNoLabel from '../../components/FormInputNoLabel/FormInputNoLabel'
import Paragraph from '../../components/Typography/Paragraph'
import Card from '../../components/Card/Card'
import Loader from 'react-js-loader'

import giftbox from '../../assets/images/giftbox.png'
import wallet from '../../assets/images/wallet.png'
import slot from '../../assets/images/slot.png'
import result from '../../assets/images/result.png'
import event from '../../assets/images/event.png'
import subscribe from '../../assets/images/subscribe.png'

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox
} from '@mui/material'
import Button from '../../components/Button/Button'
import {
  AddCircle,
  MoreVert,
  Edit,
  Delete,
  RemoveCircle
} from '@mui/icons-material'
import {
  get_brand,
  upsert_brand
} from '../../API/API'
import Countdown from 'react-countdown'
import moment from 'moment/moment'

import './styles.css'
import FormInput from '../../components/FormInput/FormInput'
import { useNavigate, useLocation } from 'react-router-dom'
import toast from 'react-simple-toasts'

export default function Brand() {
  const classes = useStyles()
  const navigate = useNavigate()
  const location = useLocation()

  const [sort, setSort] = React.useState(0)

  const handleChangeSort = event => {
    setSort(event.target.value)
  }

  const [searchKey, setSearchKey] = React.useState('')
  const handleSearch = event => {
    setSearchKey(event.target.value)
  }

  const [loading, setLoading] = useState(false)
  const [totalList, setTotalList] = React.useState(1)
  const [pageNum, setPageNum] = React.useState(0)

  const [listData, setlistData] = React.useState(null)

  const [openAdd, setOpenAdd] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [selectedBrand, setSelectedBrand] = React.useState(null);
  const [addData, setAddData] = React.useState({
    name: "",
    isinactive: "F",
    links: [],
    recordid: ""
  });

  const pageOptions = [
    { value: "shop", label: "Shop" },
    { value: "best_buy", label: "Best Buy" }
  ];

  const getData = () => {
    setLoading(true)
    get_brand({}).then(json => {
      setLoading(false)
      setlistData(json.data || [])
    }).catch(error => {
      setLoading(false)
      console.error("Error fetching brands:", error)
      toast("Error loading brands")
    })
  }

  React.useEffect(() => {
    getData()
  }, [])

  const handleChangePage = (e, ispage) => {
    setPageNum(ispage)
  }

  const handleOpenAdd = e => {
    setOpenAdd(true)
    setAddData({
      name: "",
      isinactive: "F",
      links: [],
      recordid: ""
    });
  }
  const handleCloseAdd = value => {
    setOpenAdd(false)
  }

  const handleChangeAdd = (e) => {
    if (e.target.name === "isinactive") {
      setAddData({
        ...addData,
        isinactive: e.target.checked ? "T" : "F",
      });
    } else if (e.target.name === "links") {
      const value = e.target.value;
      const checked = e.target.checked;
      let updatedLinks = [...(addData.links || [])];
      
      if (checked) {
        if (!updatedLinks.includes(value)) {
          updatedLinks.push(value);
        }
      } else {
        updatedLinks = updatedLinks.filter(p => p !== value);
      }
      
      setAddData({
        ...addData,
        links: updatedLinks,
      });
    } else {
      setAddData({
        ...addData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleAddBrand = () => {
    if (addData.name.length == 0) {
      toast("Please enter brand name")
      return
    }
    setLoading(true);
    const submitData = {
      name: addData.name,
      isinactive: addData.isinactive,
      links: addData.links,
      recordid: addData.recordid !== "" && addData.recordid !== null && addData.recordid !== undefined 
        ? parseInt(addData.recordid) 
        : 0
    };
    upsert_brand(submitData).then((json) => {
      if (json.status) {
        setLoading(false);
        toast(json.message || "Brand Added")
        handleCloseAdd();
        getData();
        setAddData({
          name: "",
          isinactive: "F",
          links: [],
          recordid: ""
        });
      } else {
        setLoading(false);
        toast(json.message || "Error adding brand")
      }
    }).catch(error => {
      setLoading(false);
      toast("Error adding brand")
      console.error(error);
    });
  };

  const handleOpenEdit = e => {
    setOpenEdit(true)
    setAddData({
      id: e.id,
      name: e.brand || e.name || "",
      isinactive: e.isinactive || "F",
      links: e.links || e.page || [],
      recordid: e.recordid || ""
    });
  }
  const handleCloseEdit = value => {
    setOpenEdit(false)
  }

  const handleEditBrand = () => {
    if (addData.name.length == 0) {
      toast("Please enter brand name")
      return
    }
    setLoading(true);
    const submitData = {
      id: addData.id,
      name: addData.name,
      isinactive: addData.isinactive,
      links: addData.links,
      recordid: (addData.recordid !== "" && addData.recordid !== null && addData.recordid !== undefined) 
        ? parseInt(addData.recordid)
        : null
    };
    upsert_brand(submitData).then((json) => {
      if (json.status) {
        setLoading(false);
        toast(json.message || "Brand Updated")
        handleCloseEdit();
        getData();
        setAddData({
          name: "",
          isinactive: "F",
          links: [],
          recordid: ""
        });
      } else {
        setLoading(false);
        toast(json.message || "Error updating brand")
      }
    }).catch(error => {
      setLoading(false);
      toast("Error updating brand")
      console.error(error);
    });
  };

  const handleOpenDelete = e => {
    setOpenDelete(true)
    setSelectedBrand(e)
  }
  const handleCloseDelete = value => {
    setOpenDelete(false)
  }
  const handleDeleteBrand = () => {
    // Note: API might not have delete endpoint, so this might need to be implemented
    // For now, we'll just close the dialog
    setLoading(true);
    // If delete API exists, call it here
    setLoading(false);
    toast("Delete functionality not implemented yet")
    handleCloseDelete();
    // getData();
  };

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: 'auto' }}>
          <Loader type='bubble-loop' bgColor='#1A5386' size={50} />
        </div>
      ) : (
        <Navbar2
          children={
            <Section pd='2rem'>
              <div>
                <div className={classes.theFlexHeader}>
                  <Paragraph color='#1A5386' bold='600' size='24px'>
                    Brand
                  </Paragraph>

                  <div
                    className={classes.theFlexBtn}
                    style={{ marginBottom: '0' }}
                  >
                    <a
                      className={classes.theCustomActionBtn_}
                      onClick={() => handleOpenAdd()}
                    >
                      <AddCircle sx={{ color: '#1A5386' }} />
                      <Paragraph color='#1A5386' margin='0 0 0 .4rem'>
                        Add Brand
                      </Paragraph>
                    </a>
                  </div>
                </div>
                <div
                  style={{
                    borderBottom: '2px solid #707070',
                    padding: '.2rem 0'
                  }}
                />
                <br />

                <div className={classes.theFlexAction}>
                  <div
                    className={classes.theWx}
                    style={{ margin: '0 20px 0 0' }}
                  >
                    <FormInputNoLabel
                      placeholder='Search'
                      border='1px solid #d7d7d7'
                      br='6px'
                      onChange={handleSearch}
                      value={searchKey}
                    />
                  </div>
                </div>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={12}>
                    <Card className={classes.theCard}>
                      <TableContainer>
                        <Table>
                          <TableHead style={{ backgroundColor: '#1A5386' }}>
                            <TableRow>
                              <TableCell
                                style={{ borderRadius: '10px 0 0 10px' }}
                                className={classes.theHeadTitle}
                              >
                                No
                              </TableCell>
                              <TableCell
                                className={classes.theHeadTitle}
                              >
                                Brand Name
                              </TableCell>
                              <TableCell
                                className={classes.theHeadTitle}
                              >
                                Status
                              </TableCell>
                              <TableCell
                                className={classes.theHeadTitle}
                              >
                                Pages
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ borderRadius: "0 10px 10px 0" }} className={classes.theHeadTitle}>
                                <MoreVert sx={{ color: "#fff" }} />
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {listData != null &&
                              listData
                                .filter(item => {
                                  if (searchKey === '') return true;
                                  return item.brand && item.brand.toLowerCase().indexOf(searchKey.toLowerCase()) > -1;
                                })
                                .map((item, index) => {
                                  return (
                                    <TableRow key={index}>
                                      <TableCell
                                        style={{
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          verticalAlign: 'top'
                                        }}
                                      >
                                        {item.recordid || "-"}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          verticalAlign: 'top'
                                        }}
                                      >
                                        {item.brand || "-"}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          verticalAlign: 'top'
                                        }}
                                      >
                                        {item.isinactive === "T" ? "Inactive" : "Active"}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          verticalAlign: 'top'
                                        }}
                                      >
                                        {(item.links || item.page) && (item.links || item.page).length > 0 
                                          ? (item.links || item.page).join(", ") 
                                          : "-"}
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          width: "10%",
                                          verticalAlign: 'top'
                                        }}
                                      >
                                        <Button
                                          onClick={() => handleOpenEdit(item)}
                                          label="Edit"
                                          color="#fff"
                                          bg="#1A5386"
                                          size="12px"
                                          pd="10px"
                                          br="5px"
                                          style={{ marginBottom: "10px" }}
                                        />
                                      </TableCell>
                                    </TableRow>
                                  )
                                })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Card>
                    <br />
                    <br />
                  </Grid>
                </Grid>
                <br />
                <br />
              </div>

              <Dialog
                onClose={handleCloseAdd}
                open={openAdd}
                fullWidth='true'
                maxWidth='sm'
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Add Brand
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormInput
                        label="Brand Name*"
                        value={addData.name}
                        textLabelColor="#000"
                        placeholder="Brand Name"
                        name="name"
                        border="1px solid #c5c5c5"
                        onChange={handleChangeAdd}
                      >
                      </FormInput>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormInput
                        label="Order No"
                        value={addData.recordid}
                        textLabelColor="#000"
                        placeholder="Order No"
                        name="recordid"
                        border="1px solid #c5c5c5"
                        type="number"
                        onChange={handleChangeAdd}
                      >
                      </FormInput>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={addData.isinactive === "T"}
                            onChange={handleChangeAdd}
                            name="isinactive"
                          />
                        }
                        label="Inactive"
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <Paragraph size="14px" bold="600" margin="0 0 0.5rem">
                        Pages:
                      </Paragraph>
                      {pageOptions.map((option) => (
                        <FormControlLabel
                          key={option.value}
                          control={
                            <Checkbox
                              checked={addData.links && addData.links.includes(option.value)}
                              onChange={handleChangeAdd}
                              name="links"
                              value={option.value}
                            />
                          }
                          label={option.label}
                        />
                      ))}
                    </Grid>
                  </Grid>
                  <Button
                    onClick={() => handleAddBrand()}
                    label="Add"
                    color="#fff"
                    bg="#1A5386"
                    size="18px"
                    pd="10px"
                    br="5px"
                    style={{ marginTop: "1rem" }}
                  />
                </DialogContent>
              </Dialog>

              <Dialog
                onClose={handleCloseEdit}
                open={openEdit}
                fullWidth='true'
                maxWidth='sm'
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Edit Brand
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormInput
                        label="Brand Name*"
                        value={addData.name}
                        textLabelColor="#000"
                        placeholder="Brand Name"
                        name="name"
                        border="1px solid #c5c5c5"
                        onChange={handleChangeAdd}
                      >
                      </FormInput>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormInput
                        label="Order No"
                        value={addData.recordid}
                        textLabelColor="#000"
                        placeholder="Order No"
                        name="recordid"
                        border="1px solid #c5c5c5"
                        type="number"
                        onChange={handleChangeAdd}
                      >
                      </FormInput>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={addData.isinactive === "T"}
                            onChange={handleChangeAdd}
                            name="isinactive"
                          />
                        }
                        label="Inactive"
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <Paragraph size="14px" bold="600" margin="0 0 0.5rem">
                        Pages:
                      </Paragraph>
                      {pageOptions.map((option) => (
                        <FormControlLabel
                          key={option.value}
                          control={
                            <Checkbox
                              checked={addData.links && addData.links.includes(option.value)}
                              onChange={handleChangeAdd}
                              name="links"
                              value={option.value}
                            />
                          }
                          label={option.label}
                        />
                      ))}
                    </Grid>
                  </Grid>
                  <Button
                    onClick={() => handleEditBrand()}
                    label="Save"
                    color="#fff"
                    bg="#1A5386"
                    size="18px"
                    pd="10px"
                    br="5px"
                    style={{ marginTop: "1rem" }}
                  />
                </DialogContent>
              </Dialog>

              <Dialog
                onClose={handleCloseDelete}
                open={openDelete}
                fullWidth='true'
                maxWidth='sm'
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Delete Brand
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <Paragraph color="#000" bold="600" size="16px" margin="0 0 1rem">
                    Are you sure to delete this brand?
                  </Paragraph>
                  <Button
                    onClick={() => handleDeleteBrand()}
                    label="Delete"
                    color="#fff"
                    bg="#1A5386"
                    size="18px"
                    pd="10px"
                    br="5px"
                    style={{ marginBottom: "10px" }}
                  />
                </DialogContent>
              </Dialog>
            </Section>
          }
        />
      )}
    </React.Fragment>
  )
}

